export default __webpack_public_path__ + "static/media/default-orange-avatar.f88f11fb.png";